export default "__VITE_ASSET__98ca7de1__"